// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"78ae2b3d","453":"6404898e","905":"4e28e281"}[chunkId] + ".chunk.js";
};